
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2020-09-20-hello-world",
      function () {
        return require("private-next-pages/blogs/2020-09-20-hello-world/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2020-09-20-hello-world"])
      });
    }
  